<template>
  <div
    class="modal_wrapper"
    @click.stop="closeModal()"
  >
    <div
      class="modal_window white_box create_report_modal"
      @click.stop=""
    >
      <div class="heading_wrapper">
        <h3 class="heading">
          Negative Keyword Filters
        </h3>
        <button
          class="close_modal close_btn"
          @click="closeModal()"
        >
          <svg
            fill="none"
            height="32"
            viewBox="0 0 32 32"
            width="32"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25 7L7 25"
              stroke="#040707"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
            <path
              d="M25 25L7 7"
              stroke="#040707"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            />
          </svg>
        </button>
      </div>

      <div class="desc">
        Use this feature to exclude phrases from your returned keyword suggestions.
      </div>

      <div class="sub_heading">
        Add a new filter
      </div>

      <div class="form_wrap">
        <custom-select
          v-model="data.expression"
          :options="{
            equals: 'Equals',
            contains: 'Contains',
            starts_with: 'Starts with',
            ends_with: 'Ends with',
          }"
          :width="'third'"
          label="Operator"
        />
        <custom-input
          v-model="data.value"
          :placeholder="'Enter keyword'"
          :validation-errors="errors"
          :width="'third'"
          label="Keyword"
        />
        <div
          class="add_button_wrap"
          @click="add()"
        >
          <button
            :disabled="loading || removing != null"
            class="btn primary_btn btn_md"
          >
            <i
              v-if="loading"
              class="fas fa-spinner fa-spin"
            />
            {{ loading ? 'Adding filter' : 'Add filter' }}
          </button>
        </div>
      </div>

      <div class="sub_heading">
        Current filters
      </div>
      <div class="table_wrapper">
        <table class="filters_table">
          <thead>
            <tr>
              <td>
                <div>
                  <span>Expression</span>
                </div>
              </td>
              <td>
                <span>Value</span>
              </td>
              <td>&nbsp;</td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(filter, index) in ignoreFilters"
              :key="index"
            >
              <td class="keyword">
                {{ expressionNiceName(filter.expression) }}
              </td>
              <td>
                {{ filter.value }}
              </td>
              <td>
                <button
                  :disabled="removing != null"
                  class="remove_btn red_btn"
                  @click="remove(index)"
                >
                  <i
                    v-if="removing === index"
                    class="fas fa-spinner fa-spin"
                  />
                  <svg
                    v-else
                    fill="none"
                    height="14"
                    viewBox="0 0 14 14"
                    width="14"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.1875 7H11.8125"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                  </svg>
                </button>
              </td>
            </tr>
            <tr>
              <td
                v-if="ignoreFilters.length === 0"
                class="text-center"
                colspan="4"
              >
                No current filters
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import CustomSelect from './../../../../reports/components/global/forms/CustomSelect.vue';
import CustomInput from './../../../../reports/components/global/forms/CustomInput.vue';

export default {
  components: {
    CustomSelect,
    CustomInput,
  },
  props: {},
  data() {
    return {
      bulkKeywords: '',
      loading: false,
      removing: null,
      errors: [],
      data: {
        expression: 'equals',
        value: '',
      },
    }
  },
  computed: {
    ...mapGetters('keywordIdeas', ['ignoreFilters']),
  },
  watch: {
    'data.keyword': {
      handler() {
        this.errors = [];
      }
    },
  },
  mounted() {
  },
  methods: {
    ...mapActions('keywordIdeas', [
      'addIgnoreFilter',
      'removeIgnoreFilter',
    ]),
    add() {
      this.loading = true;
      if (!this.data.value) {
        this.loading = false;
        this.errors = ['Please enter a keyword'];
        return;
      }
      this.addIgnoreFilter(this.data)
          .then(() => {
            this.loading = false;
            this.data.value = '';
          });
    },
    remove(index) {
      this.removing = index;
      this.removeIgnoreFilter(index)
          .then(() => {
            this.removing = null;
          });
    },
    closeModal() {
      this.$parent.showNegativeKeywords = false;
    },
    expressionNiceName(expression) {
      switch (expression) {
        case 'equals':
          return 'Equals';
        case 'contains':
          return 'Contains';
        case 'starts_with':
          return 'Starts with';
        case 'ends_with':
          return 'Ends with';
      }
    },
  },
}
</script>
<style scoped>
.modal_wrapper {
  z-index: 100;
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
  padding: 5vh 0;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.2);
}

.modal_wrapper::-webkit-scrollbar {
  width: 0;
}

.modal_window {
  z-index: 101;
  position: relative;
  margin: auto;
  max-width: 900px;
  width: 50vw;
  -webkit-box-shadow: 0px 10px 30px rgba(4, 7, 7, 0.2);
  box-shadow: 0px 10px 30px rgba(4, 7, 7, 0.2);
  border-radius: .75rem;
}

.heading_wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.close_btn {
  height: auto;
}

.heading {
  font-weight: 700;
  line-height: 1.42;
  letter-spacing: -0.042em;
  color: #040707;
  font-size: 1.5rem;
  margin-right: auto;
}

.desc {
  margin-bottom: 10px;
}

.sub_heading {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
}

.form_wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.add_button_wrap {
  display: flex;
  justify-content: center;
  width: calc(33.33% - .5rem);
}

.add_button_wrap button {
  height: 3rem;
  width: 90%;
  margin-top: 2rem;
  padding: 0;
}

.filters_table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
}

.filters_table.head {
  width: calc(100% - 15px);
  height: 15%;
}

.filters_table thead td {
  padding: .5rem;
}

.filters_table thead td span {
  font-weight: 500;
  font-size: 15px;
  line-height: 25px;
  letter-spacing: -0.25px;
  margin-right: 0.25rem;
}

.sort_title {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.sort_title.center {
  justify-content: center;
}

.sort_title.desc i {
  transform: rotate(180deg);
}

.table_body_wrap {
  max-height: 75%;
  overflow-y: scroll;
}

.filters_table tr td:first-of-type {
  width: 45%;
}

.filters_table tr td:nth-of-type(2) {
  width: 45%;
}

.filters_table tr td:nth-of-type(3) {
  width: 10%;
  text-align: center;
}

.filters_table tbody tr:nth-of-type(2n+1) {
  background: #FBFAFA;
}

.filters_table tbody tr td {
  padding: .5rem;
}

.remove_btn {
  border-radius: 8px;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
  width: 32px;
  height: 32px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-color: #F34F4F !important;
  color: #fff;
}
</style>
